import React from 'react';
import { Route } from 'react-router-dom';
import DashboardHeroPro from './views/HeroPro/DashboardHeroPro.js';
import ControlInventario from './views/HeroPro/controlinvetario.js';
import GestionMateriales from './views/HeroPro/gestionmateriales.js';
import Recicladores from './views/HeroPro/recicladores.js';

const routesArray = [
  <Route key="heropro-dashboard" path="/heropro/dashboard" element={<DashboardHeroPro />} />,
  <Route key="heropro-controlinventario" path="/heropro/inventario" element={<ControlInventario />} />,
  <Route key="heropro-gestionmateriales" path="/heropro/materiales" element={<GestionMateriales />} />,
  <Route key="heropro-proveedores" path="/heropro/recicladores" element={<Recicladores />} />,
];

export default routesArray;
